export default __webpack_public_path__ + "static/media/tcm.4a31d6af.jpeg";